import { Grid, makeStyles, Typography } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles(() => ({
  text: {
    width: '358px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '700',
    fontSize: '14px',
    lineHeight: '140%',
    display: 'flex',
    alignItems: 'center',
    color: '#10182B',
    textAlign: 'left',
  },
  subText: {
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '140%',
    display: 'flex',
    alignItems: 'center',
    color: '#667085',
    marginRight: '5px',
    marginBottom: '8px',
  },
  subTextMin: {
    width: '107px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '140%',
    display: 'flex',
    alignItems: 'center',
    color: '#10182B',
    marginTop: '8px',
  },
  container: {
    width: '530px',
    height: '110px',
    background: '#FFFFFF',
    border: '1px solid #E2E2E2',
    borderRadius: '8px',
    padding: '15px',
    marginBottom: '8px',
    marginTop: '8px',
  },
  ellipsisMessage: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '250px',
    whiteSpace: 'nowrap',
    display: 'inline-block',
  },
}));
const LeaderboardDealershipCard = ({ data }) => {
  const { name, timezone } = data;
  const classes = useStyles();
  return (
    <Grid container direction="row" justifyContent="flex-start" alignItems="center" className={classes.container}>
      <Grid item>
        <Grid container direction="column">
          {/* <Grid item>
            <Typography className={classes.subText}>{id}</Typography>
          </Grid> */}
          <Grid item>
            <Typography className={classes.text}>
              <span className={classes.ellipsisMessage}>{name}</span>
            </Typography>
          </Grid>
          <Grid item>
            <Typography className={classes.subTextMin}>{timezone}</Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default LeaderboardDealershipCard;
